import { useEffect, useState } from "react"
import useShare from "./useShare"

interface State {
    isLoading: boolean
    code?: string
}

const initialState: State = { isLoading: false }

export default function useGameCode(gameId: string): State {
    const { getGameCode } = useShare()
    const [state, setState] = useState(initialState)

    useEffect(() => {
        setState({ isLoading: true })
        getGameCode(gameId)
            .then(code => setState({ isLoading: false, code }))
            .catch(_ => setState({ isLoading: false }))
    }, [getGameCode, gameId])

    return state
}